import PepperSendError from './PepperSendError';
import PepperValidationError from './PepperValidationError';

export const isPepperSendError = (e: unknown): e is PepperSendError => {
  return e instanceof PepperSendError;
};

export const isPepperValidationError = (e: unknown): e is PepperValidationError => {
  return e instanceof PepperValidationError;
};
